import { render, staticRenderFns } from "./ManageBags.vue?vue&type=template&id=3f1c6944&"
import script from "./ManageBags.vue?vue&type=script&lang=js&"
export * from "./ManageBags.vue?vue&type=script&lang=js&"
import style0 from "./ManageBags.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ManageBags.vue"
export default component.exports